import { render, staticRenderFns } from "./pizzaItem.vue?vue&type=template&id=f5ee7290&scoped=true&"
import script from "./pizzaItem.vue?vue&type=script&lang=js&"
export * from "./pizzaItem.vue?vue&type=script&lang=js&"
import style0 from "./pizzaItem.vue?vue&type=style&index=0&id=f5ee7290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ee7290",
  null
  
)

export default component.exports